import {
  GET_ALL_PRODUCT_CATEGORIES_REQUEST,
  GET_ALL_PRODUCT_CATEGORIES_SUCCESS,
  GET_ALL_PRODUCT_CATEGORIES_FAIL,
  GET_PRODUCT_CATEGORY_REQUEST,
  GET_PRODUCT_CATEGORY_SUCCESS,
  GET_PRODUCT_CATEGORY_FAIL,
  CREATE_PRODUCT_CATEGORY_REQUEST,
  CREATE_PRODUCT_CATEGORY_SUCCESS,
  CREATE_PRODUCT_CATEGORY_FAIL,
  UPDATE_PRODUCT_CATEGORY_REQUEST,
  UPDATE_PRODUCT_CATEGORY_SUCCESS,
  UPDATE_PRODUCT_CATEGORY_FAIL,
  DELETE_PRODUCT_CATEGORY_REQUEST,
  DELETE_PRODUCT_CATEGORY_SUCCESS,
  DELETE_PRODUCT_CATEGORY_FAIL,
  TOGGLE_PRODUCT_CATEGORY_STATUS_REQUEST,
  TOGGLE_PRODUCT_CATEGORY_STATUS_SUCCESS,
  TOGGLE_PRODUCT_CATEGORY_STATUS_FAIL,
  GET_CATEGORY_PRODUCTS_REQUEST,
  GET_CATEGORY_PRODUCTS_SUCCESS,
  GET_CATEGORY_PRODUCTS_FAIL,
  RESET_PRODUCT_CATEGORY_STATE
} from "./actionTypes"

// Get all product categories
export const getAllProductCategories = (history) => ({
  type: GET_ALL_PRODUCT_CATEGORIES_REQUEST,
  payload: { history }
})

export const getAllProductCategoriesSuccess = (categories) => ({
  type: GET_ALL_PRODUCT_CATEGORIES_SUCCESS,
  payload: categories
})

export const getAllProductCategoriesFail = (error) => ({
  type: GET_ALL_PRODUCT_CATEGORIES_FAIL,
  payload: error
})

// Get single product category
export const getProductCategory = (categoryId, history) => ({
  type: GET_PRODUCT_CATEGORY_REQUEST,
  payload: { categoryId, history }
})

export const getProductCategorySuccess = (category) => ({
  type: GET_PRODUCT_CATEGORY_SUCCESS,
  payload: category
})

export const getProductCategoryFail = (error) => ({
  type: GET_PRODUCT_CATEGORY_FAIL,
  payload: error
})

// Create product category
export const createProductCategory = (categoryData, history) => ({
  type: CREATE_PRODUCT_CATEGORY_REQUEST,
  payload: { categoryData, history }
})

export const createProductCategorySuccess = (category) => ({
  type: CREATE_PRODUCT_CATEGORY_SUCCESS,
  payload: category
})

export const createProductCategoryFail = (error) => ({
  type: CREATE_PRODUCT_CATEGORY_FAIL,
  payload: error
})

// Update product category
export const updateProductCategory = (categoryId, categoryData, history) => ({
  type: UPDATE_PRODUCT_CATEGORY_REQUEST,
  payload: { categoryId, categoryData, history }
})

export const updateProductCategorySuccess = (category) => ({
  type: UPDATE_PRODUCT_CATEGORY_SUCCESS,
  payload: category
})

export const updateProductCategoryFail = (error) => ({
  type: UPDATE_PRODUCT_CATEGORY_FAIL,
  payload: error
})

// Delete product category
export const deleteProductCategory = (categoryId, mode, moveToCategoryId, history) => ({
  type: DELETE_PRODUCT_CATEGORY_REQUEST,
  payload: { categoryId, mode, moveToCategoryId, history }
})

export const deleteProductCategorySuccess = (categoryId) => ({
  type: DELETE_PRODUCT_CATEGORY_SUCCESS,
  payload: categoryId
})

export const deleteProductCategoryFail = (error) => ({
  type: DELETE_PRODUCT_CATEGORY_FAIL,
  payload: error
})

// Toggle product category status
export const toggleProductCategoryStatus = (categoryId, history) => ({
  type: TOGGLE_PRODUCT_CATEGORY_STATUS_REQUEST,
  payload: { categoryId, history }
})

export const toggleProductCategoryStatusSuccess = (response) => ({
  type: TOGGLE_PRODUCT_CATEGORY_STATUS_SUCCESS,
  payload: response
})

export const toggleProductCategoryStatusFail = (error) => ({
  type: TOGGLE_PRODUCT_CATEGORY_STATUS_FAIL,
  payload: error
})

// Get products from category
export const getCategoryProducts = (categoryId, history) => ({
  type: GET_CATEGORY_PRODUCTS_REQUEST,
  payload: { categoryId, history }
})

export const getCategoryProductsSuccess = (products) => ({
  type: GET_CATEGORY_PRODUCTS_SUCCESS,
  payload: products
})

export const getCategoryProductsFail = (error) => ({
  type: GET_CATEGORY_PRODUCTS_FAIL,
  payload: error
})

// Reset product category state
export const resetProductCategoryState = () => ({
  type: RESET_PRODUCT_CATEGORY_STATE
})